import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { CampaignInfo, DialogBase, RentalInfo } from 't4core';

@Component({
  selector: 'findCampaignDialog',
  templateUrl: 'findCampaignDialog.html',
})
export class FindCampaignDialog extends DialogBase {
  public campigns: CampaignInfo[] = [];
  public txtKeywords: FormControl = new FormControl();

  constructor(
    public dialogRef: MatDialogRef<FindCampaignDialog>, private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super("FindCampaignDialog");

    this.txtKeywords.valueChanges.pipe(debounceTime(1000))
      .subscribe(() => {
        this.findCampaigns();
      });
  }

  public static async openCampaign(dialog: MatDialog, bookingId: number, tabIndex: number = 0): Promise<RentalInfo> {
    var dlg = dialog.open(FindCampaignDialog, {
      maxHeight: "calc(100vh - 20px)",
      maxWidth: "calc(100vw - 20px)",
      width: "1200px",
      data: {
        booking: bookingId,
        tabIndex: tabIndex
      }
    });

    return await dlg.afterClosed().toPromise();
  }

  private async findCampaigns() {
    var token = this.beginLoad('Turbo.Campaign.FindCampaignDialog.msgSearching', 'Looking for campaigns', null);

    this.Api.get<CampaignInfo[]>('/Campaign/FindCampaigns', { keywords: this.txtKeywords.value }).then(x => {
      this.campigns = x;
    this.endLoad(token);
    });
  }

  public showCampaign(id: number) {
    this.dialogRef.close();
    this.router.navigateByUrl("/Campaigns/Campaign/" + id);
  }
}
